module.exports = __webpack_public_path__ + "img/Malaysia-3.67789852.jpg";